/* 
 * This script loads sticky header
 * 
 * Requires: 
 *	- jQuery
 *	- foundation.core.js 
 *	- foundation.util.triggers.js
 *	- foundation.sticky.js
 *	
 *	Author: Michael Kohler <michael.kohler@somedia.ch>
 */

// requires
var $ = require('jquery');
require('foundation-sites');

// Modul construct
var somModul = {
	
	// Module name
	name: 'foundation.sticky',
	
	// Container
	container: null,
	
	// Init function
	init: function() {
		
		// Get component config
		var componentConfig = this.__getComponentConfig(somModul.name);

		// Set container
		somModul.container = $('.sticky'); 

		if(componentConfig.enabled && somModul.container.length != 0){
			somModul.container.foundation();
			return true;
		}
	}
};

// Return modul construct - commonJS syntax
module.exports = somModul;



/** WEBPACK FOOTER **
 ** ./src/components/foundation.sticky.js
 **/